export const GRADES = [
	{ label: "الصف الأول الابتدائي", value: "1" },
	{ label: "الصف الثاني الابتدائي", value: "2" },
	{ label: "الصف الثالث الابتدائي", value: "3" },
	{ label: "الصف الرابع الابتدائي", value: "4" },
	{ label: "الصف الخامس الابتدائي", value: "5" },
	{ label: "الصف السادس الابتدائي", value: "6" },
	{ label: "الصف الأول الاعدادي", value: "7" },
	{ label: "الصف الثاني الاعدادي", value: "8" },
	{ label: "الصف الثالث الاعدادي", value: "9" },
	{ label: "الصف الأول الثانوي", value: "10" },
	{ label: "الصف الثاني الثانوي", value: "11" },
	{ label: "الصف الثالث الثانوي", value: "12" },
];

export const TEACHER_EXPLANATION_TAG = "تحتوي على شرح معلم";

export const ASSESSMENTS_TYPES = {
	pre: "PRE",
	post: "POST",
	graded: "GRADED",
};

export const COURSE_STATUS = {
	draft: "DRAFT",
	published: "PUBLISHED",
	unpublished: "UNPUBLISHED",
	pending_review: "PENDING_REVIEW",
	incomplete: "INCOMPLETE",
};

export const COURSE_REDIRECT_TYPE = {
	internal: "INTERNAL",
	external: "EXTERNAL",
};

export const COURSE_CONTENT_TYPE = [
	{ label: "Course", value: "COURSE" },
	{ label: "Video", value: "VIDEO" },
	{ label: "Book", value: "BOOK" },
	{ label: "Audiobook", value: "AUDIOBOOK" },
	{ label: "Channel", value: "CHANNEL" },
	{ label: "Journey", value: "JOURNEY" },
	{ label: "Linked Content", value: "LINKED_CONTENT" },
	{ label: "Scheduled Content", value: "SCHEDULED_CONTENT" },
	{ label: "Assessment", value: "ASSESSMENT" },
	{ label: "Dynamic Content", value: "DYNAMIC_CONTENT" },
	{ label: "Certification Path", value: "CERTIFICATION_PATH" },
];

export const COURSE_EXPERTISE_LEVEL = [
	{ label: "Beginner", value: "BEGINNER" },
	{ label: "Intermediate", value: "INTERMEDIATE" },
	{ label: "Expert", value: "EXPERT" },
	{ label: "Everyone", value: "EVERYONE" },
];

export const NPS_TYPES = {
	detractors: "Detractor",
	passives: "Passive",
	promoters: "Promoter",
};

export const APP_DEEP_LINKS = [
	{ label: "All", value: "all" },
	{ label: "Course", value: "COURSE" },
	{ label: "Category", value: "CATEGORY" },
	{ label: "Competition", value: "COMPETITION" },
];

export const NOTIFICATION_CHANNEL_TYPES = [
	{ label: "All", value: "all" },
	{ label: "SMS", value: "SMS" },
	{ label: "IN_APP", value: "IN_APP" },
	{ label: "IN_WEB", value: "IN_WEB" },
];

export const PLATFORMS = [
	{ label: "web", value: "WEB" },
	{ label: "ios", value: "IOS" },
	{ label: "android", value: "ANDROID" },
];

export const GENDER = [
	{ label: "male", value: "MALE" },
	{ label: "female", value: "FEMALE" },
];

export const SEMESTERS = [
	{ label: "First", value: "FIRST" },
	{ label: "Second", value: "SECOND" },
	{ label: "Full Year", value: "FULL_YEAR" },
];

export const NUMBERS_TO_WORDS: { [index: number]: string } = {
	0: "First",
	1: "Second",
	2: "Third",
	3: "Fourth",
	4: "Fifth",
	5: "Sixth",
	6: "Seventh",
	7: "Eighth",
	8: "Ninth",
	9: "Tenth",
	10: "Eleventh",
	11: "Twelfth",
	12: "Thirteenth",
	13: "Fourteenth",
	14: "Fifteenth",
	15: "Sixteenth",
	16: "Seventeenth",
	17: "Eighteenth",
	18: "Nineteenth",
	19: "Twentieth",
	20: "Twenty First",
	21: "Twenty Second",
	22: "Twenty Third",
	23: "Twenty Fourth",
	24: "Twenty Fifth",
	25: "Twenty Sixth",
	26: "Twenty Seventh",
	27: "Twenty Eighth",
	28: "Twenty Ninth",
	29: "Thirtieth",
	30: "Thirty First",
	31: "Thirty Second",
	32: "Thirty Third",
	33: "Thirty Fourth",
	34: "Thirty Fifth",
	35: "Thirty Sixth",
	36: "Thirty Seventh",
	37: "Thirty Eighth",
	38: "Thirty Ninth",
	39: "Fortieth",
};

export const UserRole = {
	parent: "PARENT",
	student: "STUDENT",
	teacher: "TEACHER",
	child: "CHILD",
	teacher_parent: "TEACHER_PARENT",
};

export const DEFAULT_USER_ROLE = 4;

export const MAX_OPPORTUNITIES = 3;
